import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
    createStyles({
        component: {
            marginTop: "1.8rem",
            marginBottom: "1.8rem",
            width: "100%",
            height: "324px",
            backgroundColor: "#FFFFFF",
            borderRadius: "2px",
            display: "flex",
            justifyContent: "space-between",
        },
        doc: {
            display: "flex",
            margin: "30px",
            marginRight: "10px",
            color: "#938FA3",
        },
        componentDoc: {
            width: "520px",
            height: "30px",
            backgroundColor: "#16325C",
            borderRadius: "46.06px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5px",
            marginLeft: "80px",
        },
        para: {
            color: "#fff",
            fontSize: "12px",
            fontWeight: "800",
        },
        align: {
            display: "flex",
            margin: "10px",
            marginLeft: "20px",
        },
        componentCred: {
            width: "520px",
            height: "30px",
            backgroundColor: "#16325C",
            borderRadius: "46.06px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5px",
            marginLeft: "35px",
        },
        paraCred: {
            color: "#fff",
            fontWeight: "800",
            fontSize: "12px",
            marginLeft: "10px",
        },
        componentPor: {
            width: "144px",
            height: "30px",
            backgroundColor: "#16325C",
            borderRadius: "46.06px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5px",
            marginLeft: "90px",
        },
        alignConsolidado: {
            display: "flex",
            margin: "10px",
            marginTop: "50px",
            marginLeft: "20px",
        },
        alignComponents: {

        },
        grafico: {
            height: "100%",
            marginTop: "30px",
        },

    })
);

export default useStyles;